import { CheckOutlined } from "@ant-design/icons";

type IndicatorProps = {
  actualDate: string | null;
  isCurrentMilestone: boolean;
};

function ProgressIndicatorCircle(props: IndicatorProps) {
  const { actualDate, isCurrentMilestone } = props;

  if (!actualDate)
    return (
      <div
        className={
          isCurrentMilestone
            ? "bl-circle !border-2 border-ciq-primary-900"
            : "bl-circle"
        }
      />
    );

  return (
    <div className="bl-circle">
      <div className="w-full h-full text-xs rounded-[70%] flex items-center justify-center">
        <CheckOutlined />
      </div>
    </div>
  );
}
export default ProgressIndicatorCircle;
